export const INIT: "components/INIT" = "components/INIT";
export const ADD: "components/ADD" = "components/ADD";
export const REMOVE: "components/REMOVE" = "components/REMOVE";
export const LOAD: "components/LOAD" = "components/LOAD";
export const UNLOAD: "components/UNLOAD" = "components/UNLOAD";
export const UPDATE_COMPONENT: "components/UPDATE_COMPONENT" =
  "components/UPDATE_COMPONENT";
